import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({className, width, height}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
      <title>Close</title>
      <path d="M19.382 32.555l248.251 248.282c3.905 3.906 10.237 3.906 14.142 0 3.906-3.904 3.906-10.236.001-14.141L33.525 18.414c-3.905-3.906-10.237-3.906-14.142 0-3.906 3.904-3.906 10.236-.001 14.141z"/>
      <path d="M266.475 20.352L18.224 268.634c-3.905 3.906-3.905 10.237 0 14.142 3.906 3.905 10.238 3.905 14.143 0L280.618 34.492c3.905-3.905 3.905-10.237 0-14.142-3.906-3.905-10.238-3.904-14.143.001z"/>
    </svg>
  )
}

CloseIcon.defaultProps = {
  className: '',
  width: '300px',
  height: '300px'
}

CloseIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}

export default CloseIcon;